/* eslint-disable react/no-unescaped-entities */
import './styles.css';

import HeadingArrowWrapper from '@components/ui/heading-arrow-wrapper';
import { DATA_TEST_IDS } from '@data-test-ids';
import { emailTemplate } from '@global/helpers/general';
import { Grid, Typography } from '@mui/material';

export default function PrivacyPolicy() {
  return (
    <HeadingArrowWrapper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexWrap: 'nowrap',
        height: '100%',
        padding: '0 1em',
        margin: 'auto'
      }}
      title={'Privacy Policy'}>
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{
          margin: '1em 1em',
          padding: '0 4em',
          wordBreak: 'break-word'
        }}>
        <Typography variant="body2" sx={{ margin: '4px 0' }}>
          Last updated: November 14, 2022
        </Typography>
        <br />
        <Typography variant="body1" sx={{ margin: '4px 0' }}>
          This Privacy Policy describes Our policies and procedures on the collection, use and
          disclosure of Your information when You use the Service and tells You about Your privacy
          rights and how the law protects You.
          <br />
          We use Your Personal data to provide and improve the Service. By using the Service, You
          agree to the collection and use of information in accordance with this Privacy Policy.{' '}
        </Typography>
        <Typography variant="h4" sx={{ margin: '4px 0' }}>
          Interpretation and Definitions{' '}
        </Typography>
        <Typography variant="h5" sx={{ margin: '4px 0' }}>
          Interpretation
        </Typography>
        <Typography variant="body1" sx={{ margin: '4px 0' }}>
          The words of which the initial letter is capitalized have meanings defined under the
          following conditions. The following definitions shall have the same meaning regardless of
          whether they appear in singular or in plural.{' '}
        </Typography>
        <Typography variant="h5" sx={{ margin: '4px 0' }}>
          Definitions
        </Typography>
        <Typography variant="body1" sx={{ margin: '4px 0' }}>
          For the purposes of this Privacy Policy:{' '}
        </Typography>
        <ul style={{ marginLeft: '2em' }}>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Account</b> means a unique account created for You to access our Service or parts
              of our Service.
            </Typography>
          </li>
          <li>
            <Typography
              variant="body1"
              sx={{ margin: '8px 0' }}
              data-test-id={DATA_TEST_IDS.COMPANY_DEFINITION}>
              <b>Company</b> (referred to as either "the Company", "We", "Us" or "Our" in this
              Agreement) refers to{' '}
              <span data-test-id={DATA_TEST_IDS.ORG_FULL_NAME_TEXT}>
                {import.meta.env.VITE_ORG_FULL_NAME}
              </span>
              .
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Cookies</b> are small files that are placed on Your computer, mobile device or any
              other device by a website, containing the details of Your browsing history on that
              website among its many uses.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Country</b> refers to: India.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Device</b> means any device that can access the Service such as a computer, a
              cellphone or a digital tablet.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Personal Data</b> is any information that relates to an identified or identifiable
              individual.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Service</b> refers to the Website.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Service Provider</b> means any natural or legal person who processes the data on
              behalf of the Company. It refers to third-party companies or individuals employed by
              the Company to facilitate the Service, to provide the Service on behalf of the
              Company, to perform services related to the Service or to assist the Company in
              analyzing how the Service is used.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Usage Data</b> refers to data collected automatically, either generated by the use
              of the Service or from the Service infrastructure itself (for example, the duration of
              a page visit).
            </Typography>
          </li>
          <li>
            <Typography
              variant="body1"
              sx={{ margin: '8px 0' }}
              data-test-id={DATA_TEST_IDS.WEBSITE_DEFINITION}>
              <b>Website</b> refers to{' '}
              <span data-test-id={DATA_TEST_IDS.ORG_ALTERNATE_NAME_TEXT}>
                {import.meta.env.VITE_ORG_ALTERNATE_NAME}
              </span>
              , accessible from{' '}
              <a
                href={import.meta.env.VITE_ORG_PARTNER_WEBSITE}
                data-test-id={DATA_TEST_IDS.ORG_PARTNER_WEBSITE_LINK}>
                {import.meta.env.VITE_ORG_PARTNER_WEBSITE}
              </a>
              .
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>You</b> means the individual accessing or using the Service, or the company, or
              other legal entity on behalf of which such individual is accessing or using the
              Service, as applicable.
            </Typography>
          </li>
        </ul>
        <Typography variant="h4" sx={{ margin: '4px 0' }}>
          Collecting and Using Your Personal Data
        </Typography>
        <Typography variant="h5" sx={{ margin: '4px 0' }}>
          Types of Data Collected
        </Typography>
        <ul style={{ marginLeft: '2em' }}>
          <li>
            <Typography variant="body1" sx={{ margin: '4px 0' }}>
              <b> Personal Data</b>
            </Typography>{' '}
            <Typography variant="body1" sx={{ margin: '4px 0' }}>
              While using Our Service, We may ask You to provide Us with certain personally
              identifiable information that can be used to contact or identify You. Personally
              identifiable information may include, but is not limited to:{' '}
            </Typography>
            <ul style={{ marginLeft: '2em' }}>
              <li>
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  Email address
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  First name and last name
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  Phone number
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  Address, State, Province, ZIP/Postal code, City
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  Usage Data
                </Typography>
              </li>
            </ul>
          </li>
          <li>
            {' '}
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Usage Data</b>
            </Typography>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              Usage Data is collected automatically when using the Service.
              <br />
              Usage Data may include information such as Your Device's Internet Protocol address
              (e.g. IP address), browser type, browser version, the pages of our Service that You
              visit, the time and date of Your visit, the time spent on those pages, unique device
              identifiers and other diagnostic data. When You access the Service by or through a
              mobile device, We may collect certain information automatically, including, but not
              limited to, the type of mobile device You use, Your mobile device unique ID, the IP
              address of Your mobile device, Your mobile operating system, the type of mobile
              Internet browser You use, unique device identifiers and other diagnostic data.
              <br />
              We may also collect information that Your browser sends whenever You visit our Service
              or when You access the Service by or through a mobile device.
              <br /> Our company is hosted on the Wix.com platform. Wix.com provides us with the
              online platform that allows us to sell our products and services to you. Your data may
              be stored through Wix.com’s data storage, databases, and the general Wix.com
              applications. They store your data on secure servers behind a firewall.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Tracking Technologies and Cookies </b>
            </Typography>
            <ul style={{ marginLeft: '2em' }}>
              <li>
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  <b>Cookies or Browser Cookies.</b> A cookie is a small file placed on Your Device.
                  You can instruct Your browser to refuse all Cookies or to indicate when a Cookie
                  is being sent. However, if You do not accept Cookies, You may not be able to use
                  some parts of our Service. Unless you have adjusted Your browser setting so that
                  it will refuse Cookies, our Service may use Cookies.
                </Typography>
              </li>
              <li>
                {' '}
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  <b>Flash Cookies. </b>Certain features of our Service may use local stored objects
                  (or Flash Cookies) to collect and store information about Your preferences or Your
                  activity on our Service. Flash Cookies are not managed by the same browser
                  settings as those used for Browser Cookies. For more information on how You can
                  delete Flash Cookies, please read "Where can I change the settings for disabling,
                  or deleting local shared objects?" available at{' '}
                  <a
                    href="https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change_the_settings_for_disabling__or_deleting_local_shared_objects_"
                    target="_blank"
                    rel="noreferrer">
                    https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change_the_settings_for_disabling__or_deleting_local_shared_objects_
                  </a>
                </Typography>
              </li>
              <li>
                {' '}
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  <b>Web Beacons.</b>
                  Certain sections of our Service and our emails may contain small electronic files
                  known as web beacons (also referred to as clear gifs, pixel tags, and single-pixel
                  gifs) that permit the Company, for example, to count users who have visited those
                  pages or opened an email and for other related website statistics (for example,
                  recording the popularity of a certain section and verifying system and server
                  integrity). Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies
                  remain on Your personal computer or mobile device when You go offline, while
                  Session Cookies are deleted as soon as You close Your web browser. Learn more
                  about cookies:
                  <a
                    href="https://www.freeprivacypolicy.com/blog/cookies/"
                    target="_blank"
                    rel="noreferrer">
                    Cookies: What Do They Do?.{' '}
                  </a>{' '}
                  We use both Session and Persistent Cookies for the purposes set out below:
                  <ol style={{ marginLeft: '2em' }}>
                    <li>
                      <Typography variant="h5" sx={{ margin: '8px 0' }}>
                        Necessary / Essential Cookies
                      </Typography>
                      <ul style={{ marginLeft: '2em' }}>
                        <li>
                          <Typography variant="body1" sx={{ margin: '6px 0' }}>
                            Type: Session Cookies
                          </Typography>
                        </li>
                        <li>
                          <Typography variant="body1" sx={{ margin: '6px 0' }}>
                            Administered by: Us
                          </Typography>
                        </li>
                        <li>
                          <Typography variant="body1" sx={{ margin: '6px 0' }}>
                            Purpose: These Cookies are essential to provide You with services
                            available through the Website and to enable You to use some of its
                            features. They help to authenticate users and prevent fraudulent use of
                            user accounts. Without these Cookies, the services that You have asked
                            for cannot be provided, and We only use these Cookies to provide You
                            with those services.
                          </Typography>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Typography variant="h5" sx={{ margin: '8px 0' }}>
                        Cookies Policy / Notice Acceptance Cookies
                      </Typography>
                      <ul style={{ marginLeft: '2em' }}>
                        <li>
                          <Typography variant="body1" sx={{ margin: '6px 0' }}>
                            Type: Persistent Cookies
                          </Typography>
                        </li>
                        <li>
                          <Typography variant="body1" sx={{ margin: '6px 0' }}>
                            Administered by: Us
                          </Typography>
                        </li>
                        <li>
                          <Typography variant="body1" sx={{ margin: '6px 0' }}>
                            Purpose: These Cookies identify if users have accepted the use of
                            cookies on the Website.
                          </Typography>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Typography variant="h5" sx={{ margin: '8px 0' }}>
                        Functionality Cookies
                      </Typography>
                      <ul style={{ marginLeft: '2em' }}>
                        <li>
                          <Typography variant="body1" sx={{ margin: '6px 0' }}>
                            Type: Persistent Cookies
                          </Typography>
                        </li>
                        <li>
                          <Typography variant="body1" sx={{ margin: '6px 0' }}>
                            Administered by: Us
                          </Typography>
                        </li>
                        <li>
                          <Typography variant="body1" sx={{ margin: '6px 0' }}>
                            Purpose: These Cookies allow us to remember choices You make when You
                            use the Website, such as remembering your login details or language
                            preference. The purpose of these Cookies is to provide You with a more
                            personal experience and to avoid You having to re-enter your preferences
                            every time You use the Website.
                            <br />
                            For more information about the cookies we use and your choices regarding
                            cookies, please visit our Cookies Policy or the Cookies section of our
                            Privacy Policy.
                          </Typography>
                        </li>
                      </ul>
                    </li>
                  </ol>
                </Typography>
              </li>
            </ul>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Information Collected while Using the Application</b>
              <br />
              While using Our Application, in order to provide features of Our Application, We may
              collect, with Your prior permission:
              <br />
              <ul style={{ marginLeft: '2em' }}>
                <li>
                  Pictures and other information from your Device's camera and photo library We use
                  this information to provide features of Our Service, to improve and customize Our
                  Service. The information may be uploaded to the Company's servers and/or a Service
                  Provider's server or it may be simply stored on Your device. You can enable or
                  disable access to this information at any time, through Your Device settings.
                </li>
              </ul>
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Use of Your Personal Data </b>
              <br />
              The Company may use Personal Data for the following purposes:
              <br />
              <ul style={{ marginLeft: '2em' }}>
                <li style={{ margin: '1em' }}>
                  <b>To provide and maintain our Service:</b> including to monitor the usage of our
                  Service.
                </li>
                <li style={{ margin: '1em' }}>
                  <b>To manage Your Account:</b> to manage Your registration as a user of the
                  Service. The Personal Data You provide can give You access to different
                  functionalities of the Service that are available to You as a registered user.
                </li>
                <li style={{ margin: '1em' }}>
                  <b>For the performance of a contract:</b> the development, compliance, and
                  undertaking of the purchase contract for the products, items, or services You have
                  purchased or of any other contract with Us through the Service.
                </li>
                <li style={{ margin: '1em' }}>
                  <b>To contact You:</b> To contact You by email, telephone calls, SMS, or other
                  equivalent forms of electronic communication, such as a mobile application's push
                  notifications regarding updates or informative communications related to the
                  functionalities, products, or contracted services, including the security updates,
                  when necessary or reasonable for their implementation.
                </li>
                <li style={{ margin: '1em' }}>
                  <b>To provide You with news, special offers, and general information:</b> about
                  other goods, services, and events which we offer that are similar to those that
                  you have already purchased or enquired about unless You have opted not to receive
                  such information.
                </li>
                <li style={{ margin: '1em' }}>
                  <b>To manage Your requests:</b> To attend and manage Your requests to Us.
                </li>
                <li style={{ margin: '1em' }}>
                  <b>For business transfers:</b> We may use Your information to evaluate or conduct
                  a merger, divestiture, restructuring, reorganization, dissolution, or other sale
                  or transfer of some or all of Our assets, whether as a going concern or as part of
                  bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us
                  about our Service users is among the assets transferred.
                </li>
                <li style={{ margin: '1em' }}>
                  <b>For other purposes:</b> We may use Your information for other purposes, such as
                  data analysis, identifying usage trends, determining the effectiveness of our
                  promotional campaigns, and evaluating and improving our Service, products,
                  services, marketing, and your experience.
                </li>
                <li style={{ margin: '1em' }}>
                  <b>We may share your personal information in the following situations: </b>
                  <ul style={{ marginTop: '0.6em', marginLeft: '2em' }}>
                    <li>
                      <b>With Service Providers:</b> We may share Your personal information with
                      Service Providers to monitor and analyze the use of our Service, to contact
                      You.
                    </li>
                    <li>
                      <b>For business transfers:</b> We may share or transfer Your personal
                      information in connection with, or during negotiations of, any merger, sale of
                      Company assets, financing, or acquisition of all or a portion of Our business
                      to another company.
                    </li>
                    <li>
                      <b>With Affiliates:</b> We may share Your information with Our affiliates, in
                      which case we will require those affiliates to honor this Privacy Policy.
                      Affiliates include Our parent company and any other subsidiaries, joint
                      venture partners, or other companies that We control or that are under common
                      control with Us.
                    </li>
                    <li>
                      <b>With business partners:</b> We may share Your information with Our business
                      partners to offer You certain products, services, or promotions.
                    </li>
                    <li>
                      <b>With other users:</b> When You share personal information or otherwise
                      interact in the public areas with other users, such information may be viewed
                      by all users and may be publicly distributed outside. If You interact with
                      other users or register through a Third-Party Social Media Service, Your
                      contacts on the Third-Party Social Media Service may see Your name, profile,
                      pictures, and description of Your activity. Similarly, other users will be
                      able to view descriptions of Your activity, communicate with You, and view
                      Your profile.
                    </li>
                    <li>
                      <b>With Your consent:</b> We may disclose Your personal information for any
                      other purpose with Your consent.
                    </li>
                  </ul>
                </li>
              </ul>
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Retention of Your Personal Data</b>
              <br />
              The Company will retain Your Personal Data only for as long as is necessary for the
              purposes set out in this Privacy Policy. We will retain and use Your Personal Data to
              the extent necessary to comply with our legal obligations (for example, if we are
              required to retain your data to comply with applicable laws), resolve disputes, and
              enforce our legal agreements and policies. The Company will also retain Usage Data for
              internal analysis purposes. Usage Data is generally retained for a shorter period of
              time, except when this data is used to strengthen the security or to improve the
              functionality of Our Service, or We are legally obligated to retain this data for
              longer time periods.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Transfer of Your Personal Data </b>
              <br />
              Your information, including Personal Data, is processed at the Company's operating
              offices and in any other places where the parties involved in the processing are
              located. It means that this information may be transferred to — and maintained on —
              computers located outside of Your state, province, country or other governmental
              jurisdiction where the data protection laws may differ than those from Your
              jurisdiction. Your consent to this Privacy Policy followed by Your submission of such
              information represents Your agreement to that transfer. The Company will take all
              steps reasonably necessary to ensure that Your data is treated securely and in
              accordance with this Privacy Policy and no transfer of Your Personal Data will take
              place to an organization or a country unless there are adequate controls in place
              including the security of Your data and other personal information.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Disclosure of Your Personal Data</b>
            </Typography>
            <ul style={{ marginLeft: '2em' }}>
              <li>
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  <b>Business Transactions </b>
                  If the Company is involved in a merger, acquisition or asset sale, Your Personal
                  Data may be transferred. We will provide notice before Your Personal Data is
                  transferred and becomes subject to a different Privacy Policy.
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  <b>Law enforcement </b>
                  Under certain circumstances, the Company may be required to disclose Your Personal
                  Data if required to do so by law or in response to valid requests by public
                  authorities (e.g. a court or a government agency).
                </Typography>
              </li>
              <li>
                <Typography variant="body1" sx={{ margin: '8px 0' }}>
                  <b>Other legal requirements </b>
                  The Company may disclose Your Personal Data in the good faith belief that such
                  action is necessary to:
                  <ul style={{ marginLeft: '2em' }}>
                    <li>Comply with a legal obligation </li>
                    <li>Protect and defend the rights or property of the Company </li>
                    <li>
                      Prevent or investigate possible wrongdoing in connection with the Service{' '}
                    </li>
                    <li>Protect the personal safety of Users of the Service or the public </li>
                    <li>Protect against legal liability </li>
                  </ul>
                </Typography>
              </li>
            </ul>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Security of Your Personal Data</b>
              <br />
              The security of Your Personal Data is important to Us, but remember that no method of
              transmission over the Internet, or method of electronic storage is 100% secure. While
              We strive to use commercially acceptable means to protect Your Personal Data, We
              cannot guarantee its absolute security.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Children's Privacy </b>
              <br />
              Our Service does not address anyone under the age of 13. We do not knowingly collect
              personally identifiable information from anyone under the age of 13. If You are a
              parent or guardian and You are aware that Your child has provided Us with Personal
              Data, please contact Us. If We become aware that We have collected Personal Data from
              anyone under the age of 13 without verification of parental consent, We take steps to
              remove that information from Our servers.
              <br />
              If We need to rely on consent as a legal basis for processing Your information and
              Your country requires consent from a parent, We may require Your parent's consent
              before We collect and use that information.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Links to Other Websites </b>
              <br />
              Our Service may contain links to other websites that are not operated by Us. If You
              click on a third party link, You will be directed to that third party's site. We
              strongly advise You to review the Privacy Policy of every site You visit.
              <br />
              We have no control over and assume no responsibility for the content, privacy policies
              or practices of any third party sites or services.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Changes to this Privacy Policy </b>
              <br />
              We may update Our Privacy Policy from time to time. We will notify You of any changes
              by posting the new Privacy Policy on this page.
              <br />
              We will let You know via email and/or a prominent notice on Our Service, prior to the
              change becoming effective and update the "Last updated" date at the top of this
              Privacy Policy.
              <br /> You are advised to review this Privacy Policy periodically for any changes.
              Changes to this Privacy Policy are effective when they are posted on this page.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" sx={{ margin: '8px 0' }}>
              <b>Contact Us </b>
              <br />
              If you have any questions about this Privacy Policy, You can contact us:
              <br />
              By email:
              <a
                href={emailTemplate(import.meta.env.VITE_ORG_MAIL)}
                data-test-id={DATA_TEST_IDS.ORG_MAIL_LINK}>
                {' '}
                {import.meta.env.VITE_ORG_MAIL}
              </a>
            </Typography>
          </li>
        </ul>
      </Grid>
    </HeadingArrowWrapper>
  );
}
